// BF26 /bf page behaviour (approved mock: mock/v3/app.js). Reads and writes Shopify's cart.
// The ladder and card prices come from bf26-pricing.js; the cart total shown is Shopify's own.
(function () {
  var dataEl = document.getElementById('bf-data');
  if (!dataEl || !window.BFPricing) return;
  var D = JSON.parse(dataEl.textContent), P = window.BFPricing;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CODES = D.tiers.map(function (t) { return t.code; }).filter(Boolean);
  var CODE_PCT = {}; D.tiers.forEach(function (t) { if (t.code) CODE_PCT[t.code.toUpperCase()] = t.pct; });

  // ── catalog ───────────────────────────────────────────
  var catalog = {};
  function put(p, tier) { if (p && !catalog[p.id]) catalog[p.id] = Object.assign({}, p, { tier: tier }); }
  D.shelves.forEach(function (s) { s.products.forEach(function (p) { put(p, true); }); });
  D.shelves.forEach(function (s) { (s.plain || []).forEach(function (p) { put(p, false); }); });
  if (D.kit) put(D.kit, false);
  D.bundles.forEach(function (b) { b.items.forEach(function (p) { put(p, false); }); b.ids = b.items.map(function (p) { return p.id; }); });
  var giftProduct = D.gift ? catalog[D.gift.id] : null;
  var cfg = { tiers: D.tiers, freeShippingAbove: D.freeShippingAbove, shippingFee: D.shippingFee, giftAbove: D.giftAbove,
              gift: D.gift || { id: -1 } };

  // ── Shopify cart ──────────────────────────────────────
  var shop = { items: [], item_count: 0, total_price: 0, original_total_price: 0, discount_codes: [] };
  var busy = false;
  function json(r) { if (!r.ok) throw r; return r.json(); }
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(json);
  }
  function load() { return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(json); }
  function qtyOf(id) { return shop.items.reduce(function (n, it) { return n + (it.variant_id === id ? it.quantity : 0); }, 0); }
  function keyOf(id) { var it = shop.items.filter(function (i) { return i.variant_id === id; })[0]; return it && it.key; }
  // Every cart line goes into the model: page products by their page price, anything else as fixed-price.
  function lines() {
    return shop.items.map(function (it) {
      var p = catalog[it.variant_id];
      return { id: it.variant_id, price: p ? p.price : it.original_price, qty: it.quantity, tier: !!(p && p.tier) };
    });
  }
  function run(task, msg) {
    if (busy) return; busy = true; document.documentElement.classList.add('bf-busy');
    // /cart/change.js returns the whole cart; /cart/add.js returns only the added items, so re-read then.
    task().then(function (c) { return c && typeof c.item_count === 'number' ? c : load(); })
      .then(function (c) { shop = c; update(msg); })
      .catch(function () { toast('حصلت مشكلة. جرّب تاني.'); })
      .then(function () { busy = false; document.documentElement.classList.remove('bf-busy'); });
  }
  function addMany(ids, msg) {
    var counts = {}; ids.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
    var items = Object.keys(counts).map(function (id) { return { id: Number(id), quantity: counts[id] }; });
    run(function () { return post('/cart/add.js', { items: items }); }, msg);
    track('add_to_cart', { items: items.map(function (i) { var p = catalog[i.id]; return { item_id: String(i.id), item_name: p ? p.title : '', quantity: i.quantity }; }) });
  }
  function setQty(id, q) { var k = keyOf(id); if (!k) return; run(function () { return post('/cart/change.js', { id: k, quantity: Math.max(0, q) }); }); }

  // ── helpers ───────────────────────────────────────────
  function fmt(p) {
    var v = (Math.round(p) / 100).toFixed(2).replace(/\.00$/, '');
    var a = v.split('.'); a[0] = a[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return a.join('.');
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(src, w) { if (!src) return ''; return /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function track(name, params) {
    params = Object.assign({ promotion_id: 'bf26', currency: 'EGP' }, params || {});
    if (typeof window.gtag === 'function') window.gtag('event', name, params);
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }
  var toastT;
  function toast(t, big) {
    var el = $('[data-toast]'); el.textContent = t; el.classList.toggle('big', !!big); el.classList.add('on');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('on'); }, big ? 2600 : 1800);
  }

  // ── static parts ──────────────────────────────────────
  function renderStar() {
    var k = D.kit, el = $('[data-star]'); if (!k || !el) return;
    el.innerHTML =
      '<span class="star-tag">نجم العرض</span>' +
      '<a class="star-img" href="' + esc(k.url) + '"><img src="' + img(k.img, 900) + '" alt="' + esc(k.title) + '" fetchpriority="high"></a>' +
      '<h2>' + esc(k.title) + '</h2>' +
      '<ul>' + k.points.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('') + '</ul>' +
      '<div class="star-row"><div class="star-price"><b class="num">' + fmt(k.price) + '</b> ج.م' + (k.was ? ' <s class="num">' + fmt(k.was) + '</s>' : '') + '</div>' +
      '<button class="btn btn-coral" type="button" data-add="' + k.id + '">ضيفها لسلتك</button></div>' +
      (k.note ? '<p class="star-note">' + esc(k.note) + '</p>' : '');
  }
  function renderTicker() {
    var t = D.tiers, items = [t[0].pct + '% على منتج أو اتنين', t[1].pct + '% من ' + t[1].min + ' منتجات', t[2].pct + '% من ' + t[2].min + ' وأكتر',
      'شحن مجاني فوق ' + fmt(D.freeShippingAbove), 'الخصم بيتحط لوحده'];
    if (D.kit && D.kit.was) items.splice(4, 0, 'الحقيبة بـ' + fmt(D.kit.price) + ' بدل ' + fmt(D.kit.was));
    var html = items.map(function (x) { return '<span>' + x + '</span>'; }).join('');
    $('[data-ticker]').innerHTML = html + html;
  }
  function bundleQuote(b) {
    return P.quote(b.ids.map(function (id) { var p = catalog[id]; return { id: id, price: p.price, qty: 1, tier: p.tier }; }), cfg);
  }
  // A short product name for lists: the part before « - », « | », « — », «:» or «..», without emoji.
  function shortName(t) {
    var s = String(t || '').replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/gu, '').replace(/[()]/g, '').trim();
    var parts = s.split(/\s+[-–—|]\s+|\s*\|\s*|:\s+|\.\./).map(function (x) { return x.trim(); });
    var cut = parts[0];
    // An English-only name gets its short Arabic name too («Ducktivity · فن التبطيط»).
    if (parts[1] && !/[؀-ۿ]/.test(cut) && /[؀-ۿ]/.test(parts[1]) && parts[1].length <= 18) cut += ' · ' + parts[1];
    return cut || s;
  }
  // What is inside a bundle: each item, its price inside the bundle, and its normal price.
  function bundleList(b, q) {
    return '<ul class="b-list" aria-label="محتوى الباقة">' + b.ids.map(function (id) {
      var p = catalog[id], now = p.tier ? Math.round(p.price * (100 - q.pct) / 100) : p.price;
      return '<li><a href="' + esc(p.url || '#') + '">' + esc(shortName(p.title)) + '</a>' +
        '<span><b class="num">' + fmt(now) + '</b>' + (now < p.price ? '<s class="num">' + fmt(p.price) + '</s>' : '') + '</span></li>';
    }).join('') + '</ul>';
  }
  function renderBundles() {
    var box = $('[data-bundles]');
    if (!D.bundles.length) { $('#bundles').hidden = true; return; }
    box.innerHTML = D.bundles.map(function (b) {
      var q = bundleQuote(b);
      var covers = b.ids.slice(0, 4).map(function (id, i, arr) {
        var n = arr.length, x = n === 1 ? 31 : i * (62 / (n - 1)), r = (i - (n - 1) / 2) * 7;
        return '<img src="' + img(catalog[id].img, 260) + '" alt="" loading="lazy" style="right:' + x + '%;transform:rotate(' + r + 'deg);z-index:' + (i + 1) + '">';
      }).join('');
      var meta = b.ids.length + ' منتجات' + (q.pct ? ' · خصم ' + q.pct + '%' : '') + (q.shipping === 0 ? ' · شحن مجاني' : '');
      return '<article class="bundle tone-' + esc(b.tone) + '">' +
        (q.save ? '<span class="b-save">وفّر <span class="num">' + fmt(q.save) + '</span></span>' : '') +
        '<div class="fan">' + covers + '</div>' +
        '<h3>' + esc(b.title) + '</h3><p class="line">' + esc(b.line) + '</p>' + bundleList(b, q) +
        '<p class="b-meta">' + meta + '</p>' +
        '<div class="b-price"><b class="num">' + fmt(q.total) + '</b><span>ج.م</span>' + (q.save ? '<s class="num">' + fmt(q.sub) + '</s>' : '') + '</div>' +
        '<button class="btn btn-ink" type="button" data-bundle="' + esc(b.id) + '">ضيف الباقة كلها</button></article>';
    }).join('');
  }
  function card(p, plain) {
    return '<article class="card" data-card="' + p.id + '">' +
      '<a class="cover" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + img(p.img, 400) + '" alt="" loading="lazy">' +
      (plain ? '' : '<span class="pct num" data-ppct></span>') + '</a>' +
      '<h3><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      '<div class="price"><b class="num" data-pnow></b><span class="cur">ج.م</span><s class="num" data-pwas></s></div>' +
      '<p class="hint" data-phint></p>' +
      '<div class="act" data-pact></div></article>';
  }
  function renderShelves() {
    $('[data-chips]').innerHTML = D.shelves.map(function (s) {
      var n = s.products.length + (s.plain || []).length; if (!n) return '';
      return '<a class="chip" href="#s-' + esc(s.id) + '" data-chip="s-' + esc(s.id) + '">' + esc(s.title) + ' <span class="num">' + n + '</span></a>';
    }).join('');
    $('[data-shelves]').innerHTML = D.shelves.map(function (s) {
      if (!s.products.length && !(s.plain || []).length) return '';
      var all = s.addAll && s.products.length > 1 ? '<button class="btn ' + (s.tone === 'ink' ? 'btn-white' : 'btn-ink') + ' shelf-all" type="button" data-shelf-all="' + esc(s.id) + '">ضيف السلسلة كلها (' + s.products.length + ')</button>' : '';
      return '<section class="shelf tone-' + esc(s.tone) + '" id="s-' + esc(s.id) + '"><div class="wrap">' +
        '<div class="sec-h"><div><h2>' + esc(s.title) + '</h2>' + (s.sub ? '<p>' + esc(s.sub) + '</p>' : '') + '</div>' + all + '</div>' +
        '<div class="grid">' + s.products.map(function (p) { return card(p, false); }).join('') +
        (s.plain || []).map(function (p) { return card(p, true); }).join('') + '</div></div></section>';
    }).join('');
  }

  // ── live parts ────────────────────────────────────────
  var lastPct = null;
  function messages(q) {
    var u = q.units, nt = P.nextTier(u, D.tiers), top = D.tiers[D.tiers.length - 1].pct;
    // Short on purpose: one line on a 375px phone.
    if (u === 0) return 'ضيف كتاب وخصمك يبدأ ' + D.tiers[0].pct + '%';
    if (!nt) return 'وصلت لأعلى خصم: ' + top + '%';
    var left = nt.min - u;
    return (left === 1 ? 'كتاب كمان' : left === 2 ? 'كتابين كمان' : left + ' كتب كمان') + ' = ' + nt.pct + '% على الكل';
  }
  // True when Shopify accepted one of this page's codes for the cart.
  function pageOn() { return (shop.discount_codes || []).some(function (d) { return d.applicable && CODE_PCT[String(d.code).toUpperCase()]; }); }
  function subline(q) {
    if (q.units > 0 && !pageOn()) return '<span class="ok" style="color:#ffb3a3">خصم الصفحة مش شغّال دلوقتي</span>';
    if (!q.sub) return 'شحن مجاني فوق ' + fmt(D.freeShippingAbove);
    var ship = q.shipping === 0 ? '<span class="ok">✓ الشحن مجاني</span>' : 'شحن مجاني بعد <span class="num">' + fmt(Math.ceil(q.toFreeShipping / 100) * 100) + '</span>';
    return (q.save ? 'وفّرت <span class="num">' + fmt(q.save) + '</span> · ' : '') + ship;
  }

  function update(msg) {
    var L = lines(), q = P.quote(L, cfg);
    var count = shop.item_count || 0;

    $$('[data-count]').forEach(function (e) { e.textContent = count; });
    var mp = $('[data-mpct]'); mp.textContent = (q.pct || D.tiers[0].pct) + '%'; mp.style.opacity = q.pct ? '' : '.45';
    $('[data-mmsg]').textContent = messages(q);
    $('[data-msub]').innerHTML = subline(q);
    $('[data-mtotal]').textContent = fmt(q.pay) + ' ج.م';
    $$('.m-track i').forEach(function (el, i) { el.classList.toggle('on', q.units > i); });
    if (lastPct !== null && q.pct > lastPct && q.pct > D.tiers[0].pct) {
      mp.classList.remove('pop'); void mp.offsetWidth; mp.classList.add('pop');
      toast((msg ? msg + ' · ' : '') + 'وصلت ' + q.pct + '%! كل الأسعار نزلت', true);
      track('bf_tier_reached', { tier: q.pct });
    } else if (msg) toast(msg);
    lastPct = q.pct;

    var showPct = P.tierFor(Math.max(q.units, 1), D.tiers), top = D.tiers[D.tiers.length - 1];
    $$('[data-card]').forEach(function (c) {
      var p = catalog[c.getAttribute('data-card')], qty = qtyOf(p.id);
      var now = p.tier ? Math.round(p.price * (100 - showPct) / 100) : p.price;
      var was = p.tier ? p.price : p.was;
      $('[data-pnow]', c).textContent = fmt(now);
      $('[data-pwas]', c).textContent = was ? fmt(was) : '';
      var pp = $('[data-ppct]', c); if (pp) pp.textContent = '−' + showPct + '%';
      $('[data-phint]', c).textContent = p.tier ? (showPct < top.pct ? 'لو وصلت ' + top.min + ' كتب: ' + fmt(Math.round(p.price * (100 - top.pct) / 100)) : 'بأعلى خصم') : 'سعرها ثابت · بتتحسب في الشحن';
      c.classList.toggle('in', qty > 0);
      $('[data-pact]', c).innerHTML = qty > 0
        ? '<div class="step"><button type="button" data-dec="' + p.id + '" aria-label="شيل واحد">−</button><output class="num">' + qty + '</output><button type="button" data-inc="' + p.id + '" aria-label="زوّد واحد">+</button></div>'
        : '<button class="add" type="button" data-add="' + p.id + '">ضيف للسلة</button>';
    });

    renderCart(L, q);
  }

  function renderCart(L, q) {
    var box = $('[data-cart]');
    if (!shop.items.length) { box.innerHTML = '<p class="empty">سلتك فاضية. ابدأ بباقة جاهزة أو اختار كتاب.</p>'; return; }
    var ladder = '<div class="p-ladder"><div class="m-row" style="grid-template-columns:auto 1fr"><div class="m-pct num">' + (q.pct || D.tiers[0].pct) + '%</div><div><div class="m-msg">' + messages(q) + '</div><div class="m-sub">' + subline(q) + '</div></div></div></div>';
    var rows = shop.items.map(function (it) {
      var p = catalog[it.variant_id];
      return '<li class="ln"><img src="' + img(it.image, 120) + '" alt=""><div><div class="ln-t">' + esc(it.product_title) + '</div><div class="ln-p"><span class="num">' + fmt(it.original_line_price) + '</span>' + (p && p.tier ? '' : ' · سعر ثابت') + '</div></div>' +
        '<div class="step"><button type="button" data-dec="' + it.variant_id + '" aria-label="شيل واحد من ' + esc(it.product_title) + '">−</button><output class="num">' + it.quantity + '</output><button type="button" data-inc="' + it.variant_id + '" aria-label="زوّد واحد من ' + esc(it.product_title) + '">+</button></div></li>';
    }).join('');
    var offer = giftProduct ? P.giftOffer(L, cfg, giftProduct.price) : null, giftBox = '';
    if (offer) {
      giftBox = '<div class="gift"><b>كتاب «' + esc(giftProduct.title) + '» هدية</b><p>طلبك عدّى ' + fmt(D.giftAbove) + '. لو ضفته، الهدية هتبقى أوفر من خصمك، وهتدفع <span class="num">' + fmt(offer.extra) + '</span> جنيه زيادة بس بدل <span class="num">' + fmt(offer.giftPrice) + '</span>.</p>' +
        '<button class="btn btn-ink" type="button" data-add="' + giftProduct.id + '" style="width:100%">ضيف الهدية</button></div>';
    }
    // Shopify's own numbers: what the customer will actually be charged.
    var sub = shop.original_total_price, total = shop.total_price;
    var ship = total > D.freeShippingAbove ? 0 : D.shippingFee;
    var offs = discounts();
    var warn = (!pageOn() && q.units > 0) ? '<p class="p-warn">خصم الصفحة مش شغّال على سلتك دلوقتي.</p>' : '';
    box.innerHTML = ladder + '<ul class="lines">' + rows + '</ul>' + giftBox +
      '<div class="sum"><div><span>المجموع</span><span class="num">' + fmt(sub) + '</span></div>' +
      offs.map(function (o) { return '<div class="save"><span>' + esc(o.label) + '</span><span class="num">−' + fmt(o.amount) + '</span></div>'; }).join('') +
      '<div><span>الشحن</span><span>' + (ship ? '<span class="num">' + fmt(ship) + '</span>' : 'مجاني') + '</span></div>' +
      '<div class="tot"><span>الإجمالي</span><span class="num">' + fmt(total + ship) + '</span></div></div>' + warn +
      '<p class="p-note">الرقم النهائي بيظهر في صفحة الدفع، والخصم الأوفر بيتطبق تلقائي.</p>' +
      '<a class="btn btn-coral p-go" href="/checkout" data-checkout>كمّل الطلب</a>';
  }

  // The discounts Shopify actually applied, grouped by name. A page code shows as «خصم 25%».
  function discounts() {
    var by = {};
    function add(title, amount) {
      var pct = CODE_PCT[String(title).toUpperCase()];
      var label = pct ? 'خصم ' + pct + '%' : (giftProduct && /هدية|gift/i.test(title) ? 'كتاب هدية' : title);
      by[label] = (by[label] || 0) + amount;
    }
    shop.items.forEach(function (it) { (it.line_level_discount_allocations || []).forEach(function (a) { add(a.discount_application.title, a.amount); }); });
    (shop.cart_level_discount_applications || []).forEach(function (a) { add(a.title, a.total_allocated_amount); });
    return Object.keys(by).filter(function (k) { return by[k] > 0; }).map(function (k) { return { label: k, amount: by[k] }; });
  }

  // ── events ────────────────────────────────────────────
  var drawer = $('#drawer'), lastFocus = null;
  function openDrawer() { lastFocus = document.activeElement; drawer.hidden = false; drawer.classList.add('open'); document.body.style.overflow = 'hidden'; $('.x', drawer).focus(); }
  function closeDrawer() { drawer.classList.remove('open'); drawer.hidden = true; document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  var pendingFocus = null;

  document.addEventListener('click', function (e) {
    var t = e.target.closest('button,a'); if (!t) return;
    var id;
    if ((id = t.getAttribute('data-add'))) { addMany([Number(id)], 'اتضاف: ' + (catalog[id] ? catalog[id].title : '')); return; }
    if ((id = t.getAttribute('data-inc'))) { pendingFocus = [t.closest('#drawer') ? 'drawer' : 'card', 'data-inc', id]; setQty(Number(id), qtyOf(Number(id)) + 1); return; }
    if ((id = t.getAttribute('data-dec'))) { pendingFocus = [t.closest('#drawer') ? 'drawer' : 'card', 'data-dec', id]; setQty(Number(id), qtyOf(Number(id)) - 1); return; }
    if ((id = t.getAttribute('data-bundle'))) {
      var b = D.bundles.filter(function (x) { return x.id === id; })[0];
      addMany(b.ids, 'الباقة اتضافت'); track('select_promotion', { creative_name: 'bundle_' + b.title }); return;
    }
    if ((id = t.getAttribute('data-shelf-all'))) {
      var s = D.shelves.filter(function (x) { return x.id === id; })[0];
      addMany(s.products.map(function (p) { return p.id; }), s.title + ' اتضافت'); return;
    }
    if (t.hasAttribute('data-open')) { openDrawer(); return; }
    if (t.hasAttribute('data-close')) { closeDrawer(); return; }
    if (t.hasAttribute('data-checkout')) { track('begin_checkout', { value: shop.total_price / 100 }); return; }
  });
  $('.scrim', drawer).addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
  // After a −/+ redraw, put focus back on the same control (or the close button if the line is gone).
  var baseUpdate = update;
  update = function (msg) {
    baseUpdate(msg);
    if (!pendingFocus) return;
    var f = pendingFocus; pendingFocus = null;
    var again = $((f[0] === 'drawer' ? '#drawer ' : '[data-card="' + f[2] + '"] ') + '[' + f[1] + '="' + f[2] + '"]');
    if (again) again.focus(); else if (f[0] === 'drawer' && !drawer.hidden) $('.x', drawer).focus();
  };

  if ('IntersectionObserver' in window) {
    var chips = $$('[data-chip]');
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) chips.forEach(function (c) { c.setAttribute('aria-current', String(c.getAttribute('data-chip') === en.target.id)); }); });
    }, { rootMargin: '-40% 0px -55% 0px' });
    $$('.shelf').forEach(function (s) { so.observe(s); });
  }

  renderStar(); renderTicker(); renderBundles(); renderShelves(); update();
  track('view_promotion', { creative_name: 'bf_page' });
  // Put this page's discount codes on the visitor's cart (Shopify applies the best one). One call sets them all:
  // /discount/A,B,C does NOT split codes, /cart/update.js with a comma list does (checked 2026-10-24).
  var codesReady = CODES.length ? post('/cart/update.js', { discount: CODES.join(',') }).catch(function () { return null; }) : Promise.resolve(null);
  codesReady.then(function (c) { return c && typeof c.item_count === 'number' ? c : load(); })
    .then(function (c) { shop = c; update(); }).catch(function () {});
})();
